'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FREE = exports.FREE = 'FREE';
var PORTAL_BASED = exports.PORTAL_BASED = 'PORTAL_BASED';
var SEAT_BASED = exports.SEAT_BASED = 'SEAT_BASED';
var CONTACT_BASED = exports.CONTACT_BASED = 'CONTACT_BASED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/PurchaseTypes.js
// module id = 178
// module chunks = 3 4 5